import { BaseContainerModel } from '../../base-container.model';
import { bl_crm_label_link_RowClass } from '../../../dbschema';

export class LabelCrmLinkContainerModel extends BaseContainerModel {
  bl_crm_label_link: bl_crm_label_link_RowClass = new bl_crm_label_link_RowClass();
}
